/**
 * [AI GENERATED CODE] Helper functions for building Stripe error analytics payloads
 * Centralized to avoid duplication across purchase components
 */

/**
 * Builds standardized analytics payloads for Stripe errors
 * @param {Object} baseProps - Base properties to include in both payloads
 * @param {Object} data - API response data containing error information
 * @param {string} planCode - Subscription plan code for the stripe error event
 * @returns {Object} Object containing stripeErrorEventProperties and paymentPageErrorEventProperties
 */
export function buildStripeErrorPayloads(data, planCode, baseProps = {}) {
  // [AI GENERATED CODE] Extract stripe error details from API response
  const stripeError = data.stripe_error || data.stripeError || null;
  const stripeErrorCode = data.stripe_error_code || data.stripeErrorCode || null;

  // [AI GENERATED CODE] Build analytics properties with conditional stripe error details
  const stripeErrorEventProperties = {
    ...baseProps,
    "Subscription Plan": planCode,
    "message": data.error,
  };

  const paymentPageErrorEventProperties = {
    ...baseProps,
    "Error Message": data.error,
    "Error Type": "Stripe Error",
  };

  // Add stripe error properties only if they have values
  if (stripeError) {
    stripeErrorEventProperties["Stripe Error"] = stripeError;
    paymentPageErrorEventProperties["Stripe Error"] = stripeError;
  }
  if (stripeErrorCode) {
    stripeErrorEventProperties["Stripe Error Code"] = stripeErrorCode;
    paymentPageErrorEventProperties["Stripe Error Code"] = stripeErrorCode;
  }

  return { stripeErrorEventProperties, paymentPageErrorEventProperties };
}

/**
 * Builds analytics payload for purchaseFormSubmitErrorEvent with stripe error details
 * @param {Object} data - API response data containing error information
 * @returns {Object} Analytics properties for purchaseFormSubmitErrorEvent
 */
export function buildPurchaseFormErrorPayload(data) {
  // [AI GENERATED CODE] Extract stripe error details from API response
  const stripeError = data.stripe_error || data.stripeError || null;
  const stripeErrorCode = data.stripe_error_code || data.stripeErrorCode || null;
  
  // [AI GENERATED CODE] Build purchaseFormSubmitErrorEvent properties with conditional stripe error details
  const purchaseFormErrorEventProperties = {
    "Error Message": data.error,
    "Error Step": "subscribe_product_failed",
    "Error Message From Api": data.error,
  };

  // Add stripe error details if available
  if (stripeError) {
    purchaseFormErrorEventProperties["Stripe Error"] = stripeError;
  }
  if (stripeErrorCode) {
    purchaseFormErrorEventProperties["Stripe Error Code"] = stripeErrorCode;
  }

  return purchaseFormErrorEventProperties;
}